import React from 'react';

const PrivacyPolicy: React.FC = () => {
  return (
    <div className="min-h-screen bg-white text-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
        <p className="text-sm text-gray-500 mb-8">Effective Date: {new Date().toLocaleDateString()}</p>

        <p className="mb-4">CosmoComply ("we," "our," "us") respects your privacy and is committed to protecting the personal information you share with us. This Privacy Policy explains how we collect, use, and safeguard your information.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Account Information: name, email, company, password (encrypted).</li>
          <li>Compliance Data: facility details, product listings, adverse event records, safety substantiation documents.</li>
          <li>Usage Data: log files, browser type, access times.</li>
          <li>Support Data: information you voluntarily provide via email/chat.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Provide access to the CosmoComply platform.</li>
          <li>Generate compliance reports (e.g., FDA-ready packs).</li>
          <li>Send reminders about deadlines (e.g., renewals, annual listings).</li>
          <li>Improve and secure our services.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">3. Data Retention</h2>
        <p className="mb-2">Adverse event data is retained for 6 years (per MoCRA). Other data is retained as long as you maintain an account. You may request deletion of your account and associated data at any time, subject to regulatory requirements.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">4. Security</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Passwords are hashed and salted.</li>
          <li>All communication is encrypted via SSL (HTTPS).</li>
          <li>We do not store payment data (handled by third-party processors).</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">5. Sharing of Data</h2>
        <p className="mb-2">We do not sell or share your data with third parties. Data may be shared if required by law or regulatory authorities.</p>

        <h2 className="text-xl font-semibold mt-6 mb-2">6. Your Rights</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Access, correct, or delete your information.</li>
          <li>Opt-out of non-essential communications.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6 mb-2">7. Contact</h2>
        <p>For questions: <a className="text-indigo-600 hover:underline" href="mailto:cosmacomply@gmail.com">cosmacomply@gmail.com</a></p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;


